import acordeon from "../lib/aria/acordeon";
import parseHTML from "../lib/dom/funciones/parse_html";

const ideas = () => acordeon('.portada__ideas__lista');

const cocinas = () => {
    const contenedor = document.querySelector('.portada__cocinas') as HTMLElement;

    if (!contenedor) return;

    const listado = contenedor.querySelector('.portada__cocinas__listado') as HTMLElement,
        elementos = [].slice.call(listado.querySelectorAll('.portada__cocinas__cocina')) as HTMLElement[],
        navegacion = parseHTML(`<div class="portada__cocinas__navegacion animado"></div>`),
        anterior = parseHTML(`<button class="portada__cocinas__anterior" type="button">Anterior</button>`),
        siguiente = parseHTML(`<button class="portada__cocinas__siguiente" type="button">Siguiente</button>`);

    let ancho = elementos[1].offsetLeft - elementos[0].offsetLeft;

    const actualiza = () => {
        const imagen = contenedor.querySelector('img') as HTMLImageElement;

        contenedor.style.setProperty('--alto-imagen', `${imagen.height}px`);
        ancho = elementos[1].offsetLeft - elementos[0].offsetLeft;
    }

    addEventListener('resize', actualiza);
    addEventListener('orientationchange', actualiza);
    addEventListener('load', actualiza);
    actualiza();

    anterior.addEventListener('click', () => {
        listado.scrollTo({
            left: listado.scrollLeft - ancho,
            behavior: 'smooth'
        });
    });

    siguiente.addEventListener('click', () => {
        listado.scrollTo({
            left: listado.scrollLeft + ancho,
            behavior: 'smooth'
        });
    });

    navegacion.appendChild(anterior);
    navegacion.appendChild(siguiente);
    contenedor.appendChild(navegacion);
}

const portada = () => {
    ideas();
    cocinas();
}

export default portada;